var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15V13.25M21 15V13.25M1 11.5V8.86413C1 7.90364 1.77863 7.125 2.73913 7.125V7.125M1 11.5H21M1 11.5V13.25M21 11.5V8.86413C21 7.90364 20.2214 7.125 19.2609 7.125V7.125M21 11.5V13.25M1 13.25H21M2.73913 7.125V3C2.73913 1.89543 3.63456 1 4.73913 1H17.2609C18.3654 1 19.2609 1.89543 19.2609 3V7.125M2.73913 7.125H5.78261M19.2609 7.125H16.2174M5.78261 7.125L5.38284 6.99091C4.87653 6.82108 4.593 6.2834 4.73887 5.76968L5.14144 4.35186C5.26356 3.92177 5.65633 3.625 6.10342 3.625H8.69565C9.24794 3.625 9.69565 4.07272 9.69565 4.625V6.07119C9.69565 6.44906 9.48265 6.79466 9.1451 6.9645L8.82609 7.125M5.78261 7.125H8.82609M16.2174 7.125L16.6172 6.99091C17.1235 6.82108 17.407 6.2834 17.2611 5.76968L16.8586 4.35186C16.7364 3.92177 16.3437 3.625 15.8966 3.625H13.3043C12.7521 3.625 12.3043 4.07272 12.3043 4.625V6.07119C12.3043 6.44906 12.5173 6.79466 12.8549 6.9645L13.1739 7.125M16.2174 7.125H13.1739M13.1739 7.125H8.82609",
    stroke: "#097FE6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.c56c5174ac157c68a736b72e82f8e710.svg";
export { ForwardRef as ReactComponent };